/**
 * Layout component that queries for data
 * with Gatsby's useStaticQuery component
 *
 * See: https://www.gatsbyjs.org/docs/use-static-query/
 */

import React, { useEffect, useState, useCallback } from "react"
import PropTypes from "prop-types"
import "slick-carousel/slick/slick.css"

import CommonContext from "@src/context"
import classNames from "@utils/classnames"
import { config as wechatConfig, share as wechatShare } from "@utils/wechat"

import SEO from "@components/seo"
import Nav from "@components/nav"
import Footer from "@components/footer"
import Header from "@components/header"
import Events from "@components/events"
import ToTop from "@components/toTop"

import styles from "./layout.module.scss"

let timeout = null

function windowScrollY() {
  return window.pageYOffset !== undefined
    ? window.pageYOffset
    : (document.documentElement || document.body.parentNode || document.body)
        .scrollTop
}

const Layout = ({ children, path }) => {
  const [winWidth, setWinWidth] = useState(1000)
  const [scrollY, setScrollY] = useState(0)
  const [curBg, setCurBg] = useState(null)
  const [bg, setBg] = useState(null)

  const calcLayout = () => {
    const w = window.innerWidth
    setWinWidth(w)
    setScrollY(windowScrollY())
    timeout = null
  }

  const calcEvent = useCallback(() => {
    if (timeout) {
      clearTimeout(timeout)
    }
    timeout = setTimeout(() => {
      calcLayout()
    }, 300)
  }, [])

  useEffect(() => {
    wechatConfig()
    wechatShare({
      title: "Spark锦标赛2020年度赛事S1线上资格赛正式公布",
      desc: "喷喷、乱斗和怪猎，我们全都要",
    })
  }, [])

  useEffect(() => {
    window.addEventListener("resize", calcEvent)
    window.addEventListener("scroll", calcEvent)
    calcLayout()

    return () => {
      window.removeEventListener("resize", calcEvent)
      window.removeEventListener("scroll", calcEvent)
    }
  }, [calcEvent])

  useEffect(() => {
    setTimeout(() => {
      setCurBg(bg)
    }, 1300)
  }, [bg])

  return (
    <CommonContext.Provider value={{ winWidth, scrollY, path, setBg }}>
      <SEO />
      <Nav />
      <Header />
      <div className={styles.events}>
        <Events />
      </div>
      <main
        className={styles.container}
        style={curBg ? { backgroundImage: `url(${curBg})` } : undefined}
      >
        <img src={bg} className={styles.preloadImg} />
        <div
          className={classNames(styles.bg, {
            [styles.changing]: curBg !== bg,
          })}
        />
        <div className={styles.content}>{children}</div>
      </main>
      <Footer />
      <ToTop />
    </CommonContext.Provider>
  )
}

Layout.propTypes = {
  children: PropTypes.node.isRequired,
}

export default Layout
